import { commonConstants } from '../_constants';
import { commonService } from '../_services';
import config from 'config'
import Crypto from 'crypto-js'

const commonActions = {
    logout,
    insert,
    getAll,
    getFrequentCostUnitData,
    getFrequentSubCategoryData,
    update,
    delete: _delete
};
export default commonActions

function logout() {
    commonService.logout();
    return { type: commonConstants.LOGOUT };
}

function insert(common) {
    return async dispatch => {
        dispatch(request());

        await commonService.insert(common)
            .then(
                message => dispatch(success(message)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: commonConstants.INSERT_REQUEST } }
    function success(common) { return { type: commonConstants.INSERT_SUCCESS, common } }
    function failure(error) { return { type: commonConstants.INSERT_FAILURE, error } }
}

function getAll(CommonType) {
    return async dispatch => {
        dispatch(request());

        await commonService.getAll(CommonType)
            .then(

                commons => dispatch(
                    CommonType === 'CostUnit' ? COSTUNIT_success(commons) :
                        CommonType === 'Location' ? LOCATION_success(commons) :
                            CommonType === 'SubCategory' ? SUBCATEGORY_success(commons) : null
                ),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: commonConstants.GETALL_REQUEST } }

    function LOCATION_success(commons) {
        var _ciphertext = Crypto.AES.decrypt(commons.encryptresult.toString(), `${config.AESKEY}`);
        var decryptedData = JSON.parse(_ciphertext.toString(Crypto.enc.Utf8));
        return { type: commonConstants.GETALL_LOCATION_SUCCESS, decryptedData }
    }
    function COSTUNIT_success(commons) {
        var _ciphertext = Crypto.AES.decrypt(commons.encryptresult.toString(), `${config.AESKEY}`);
        var decryptedData = JSON.parse(_ciphertext.toString(Crypto.enc.Utf8));
        return { type: commonConstants.GETALL_COSTUNIT_SUCCESS, decryptedData }
    }
    function SUBCATEGORY_success(commons) {
        var _ciphertext = Crypto.AES.decrypt(commons.encryptresult.toString(), `${config.AESKEY}`);
        var decryptedData = JSON.parse(_ciphertext.toString(Crypto.enc.Utf8));
        return { type: commonConstants.GETALL_SUBCATEGORY_SUCCESS, decryptedData }
    }

    function failure(error) { return { type: commonConstants.GETALL_FAILURE, error } }
}

function getFrequentCostUnitData(UserId) {
    return async dispatch => {
        dispatch(request());

        await commonService.getFrequentCostUnitData(UserId)
            .then(
                commons => dispatch(success(commons)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: commonConstants.GET_FREQUENTCOSTUNITDATA_REQUEST } }

    function success(commons) {
        var _ciphertext = Crypto.AES.decrypt(commons.encryptresult.toString(), `${config.AESKEY}`);
        var decryptedData = JSON.parse(_ciphertext.toString(Crypto.enc.Utf8));
        return { type: commonConstants.GET_FREQUENTCOSTUNITDATA_SUCCESS, decryptedData }
    }

    function failure(error) { return { type: commonConstants.GET_FREQUENTCOSTUNITDATA_FAILURE, error } }
}

function getFrequentSubCategoryData(UserId) {
    return async dispatch => {
        dispatch(request());

        await commonService.getFrequentSubCategoryData(UserId)
            .then(
                commons => dispatch(success(commons)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: commonConstants.GET_FREQUENTSUBCATEGORYDATA_REQUEST } }

    function success(commons) {
        var _ciphertext = Crypto.AES.decrypt(commons.encryptresult.toString(), `${config.AESKEY}`);
        var decryptedData = JSON.parse(_ciphertext.toString(Crypto.enc.Utf8));
        return { type: commonConstants.GET_FREQUENTSUBCATEGORYDATA_SUCCESS, decryptedData }
    }

    function failure(error) { return { type: commonConstants.GET_FREQUENTSUBCATEGORYDATA_FAILURE, error } }
}

function update(common) {
    return async dispatch => {
        dispatch(request());

        await commonService.update(common)
            .then(
                message => dispatch(success(message)),
                error => dispatch(failure(error.toString()))
            );
    };
    function request() { return { type: commonConstants.UPDATE_REQUEST } }
    function success(message) { return { type: commonConstants.UPDATE_SUCCESS, message } }
    function failure(error) { return { type: commonConstants.UPDATE_FAILURE, error } }
}

function _delete(common) {
    return async dispatch => {
        dispatch(request(common));

        await commonService.delete(common)
            .then(
                message => dispatch(success(common)),
                error => dispatch(failure(common, error.toString()))
            );
    };

    function request(common) { return { type: commonConstants.DELETE_REQUEST, common } }
    function success(common) { return { type: commonConstants.DELETE_SUCCESS, common } }
    function failure(common, error) { return { type: commonConstants.DELETE_FAILURE, common, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/common.actions.js